module.exports = __webpack_public_path__ + "img/symbol_8.4c1e5257.png";